import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin(() => {
  /*<script async src="https://www.googletagmanager.com/gtag/js?id=G-CWPSFPYS3K"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-CWPSFPYS3K');
</script>*/
});
